import { MediaEmbedElement } from '@typedream/core';
import { getNode, setNodes } from '@udecode/plate-core';
import { Path } from 'slate';
import { DreamEditor } from '../../../types';

const convertURL = (url: string) => {
  const pattern1 = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;
  const pattern2 = /(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|embed\/)?(.+)/g;
  // var pattern3 = /([-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?(?:jpg|jpeg|gif|png))/gi;
  const pattern4 = /"https(.*?)"/g;

  let width = 500;
  let height = 500;
  let convertedURL = url;

  if (pattern1.test(url)) {
    const replacement = 'https://player.vimeo.com/video/$1';
    width = 560;
    height = 315;
    convertedURL = url.replace(pattern1, replacement);
  }

  if (pattern2.test(url)) {
    const replacement = 'https://www.youtube.com/embed/$1';
    width = 560;
    height = 315;
    convertedURL = url.replace(pattern2, replacement);
  }
  if (url?.includes('iframe') || url?.includes('div')) {
    if (url?.includes('google.com/maps')) {
      width = 600;
      height = 450;
    } else if (url.includes('typeform.com') || url.includes('tally.so')) {
      width = 700;
      height = 500;
    } else {
      width = 560;
      height = 315;
    }
    convertedURL = url.match(pattern4)?.toString().replace(/"/g, '') || url;
  }

  return { url: convertedURL, width, height };
};

export const changeEmbed = (
  editor: DreamEditor,
  type: 'url' | 'html' | 'file',
  content: string,
  options: { at: Path },
) => {
  const node = getNode<MediaEmbedElement>(editor, options.at);

  if (node?.type !== 'media_embed') return;

  const properties: Pick<MediaEmbedElement, 'url' | 'html' | 'file'> = {
    url: undefined,
    html: undefined,
    file: undefined,
    [type]: content,
    ...(type === 'url' ? convertURL(content) : {}),
    ...(type === 'file' ? { width: 500, height: 500 } : {}),
  };

  setNodes(editor, properties, options);
};
